<template>
  <v-select
    class="vue-select-custom-multiple"
    :options="options"
    multiple
    :error="error"
    :taggable="taggable"
    :value="value"
    :disabled="disabled"
    :clearable="true"
    @input="$emit('input', $event)"
    :placeholder="placeholder"
  >
    <template
      #selected-option-container="{ option }"
    >
      <template v-if="option.label == 'Owner Klinik'">
        <div class="vs__selected" style="background-color:#88908b !important">Pemilik Faskes</div>
      </template>
       <template  v-else-if="option.label == 'Dokter' && authrole == 2">
          <div class="vs__selected" style="background-color:#88908b !important">Dokter</div>
       </template>
       <template  v-else-if="option.label == 'PIC Faskes' && authrole == 3">
          <div class="vs__selected" style="background-color:#88908b !important">PIC Faskes</div>
       </template>
       <template  v-else-if="option.label == 'Pemilik Faskes' && authrole == 1">
          <div class="vs__selected" style="background-color:#88908b !important">Pemilik Faskes</div>
       </template>
       <template  v-else-if="option.label == 'Pemilik Faskes' && authrole == 2">
          <div class="vs__selected" style="background-color:#88908b !important">Pemilik Faskes</div>
       </template>
       <template  v-else-if="option.label == 'Manajemen' && authrole == 2 && manajemen == 1">
          <div class="vs__selected" style="background-color:#88908b !important">Manajemen</div>
       </template>
       <template  v-else-if="option.label == 'Manajemen' && authrole == 3 && manajemen == 1">
          <div class="vs__selected" style="background-color:#88908b !important">Manajemen</div>
       </template>
       <!-- <template  v-else-if="option.label == 'Perawat' && authrole == 3">
          <div class="vs__selected" style="background-color:#88908b !important">Perawat</div>
       </template>
       <template  v-else-if="option.label == 'Front Desk' && authrole == 3">
          <div class="vs__selected" style="background-color:#88908b !important">Front Desk</div>
       </template> -->
    </template>
  </v-select>
</template>

<script>
import "vue-select/dist/vue-select.css";

export default {
  components: {
    "v-select": () => import("vue-select")
  },
  data: () => ({
    // Deselect: {
    //   render: createElement => createElement("span", "❌")
    // }
  }),
  props: {
    error: Boolean,
    options: {
      type: Array,
      default: () => []
    },
    taggable: {
      type: Boolean,
      default: false
    },
    value: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    },
    authrole : {
      type : Number,
      default : null,
    },
    manajemen : {
      type : Number,
      default : null,
    }
  },
  methods: {
    inputEvent($event) {
      // console.log($event)
    }
  }
};
</script>

<style lang="scss">
.vue-select-custom-multiple .vs__dropdown-toggle .vs__selected-options .vs__selected {
  background-color: #1484c9 !important;
  color: white;
}

.v-select {
  &.vue-select-custom-multiple {
    & > .vs__dropdown-toggle {
      height: auto !important;
    }

    &.error {
      & > .vs__dropdown-toggle {
        border-color: red;
      }
    }
  }
  &.custom-v-select-manajemen-tarif {
    & > .vs__dropdown-toggle {
      height: auto !important;
    }

    &.error {
      & > .vs__dropdown-toggle {
        border-color: red;
      }
    }
  }
}
</style>
